import NextImage from 'next/image';
import {DetailAd} from './DetailAd';
import addImg from 'images/banner/O2_Internet_pocasi_750x110_dest.jpg';

export const DetailO2 = () => {
    return (
        <DetailAd>
            <a
                href="https://ad.doubleclick.net/ddm/trackclk/N1215814.1920760BEZREALITKY/B27124403.328259894;dc_trk_aid=520556863;dc_trk_cid=166191266;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd="
                target="_blank"
            >
                <NextImage src={addImg} placeholder="blur" alt="O2" layout="fill" />
            </a>
            <img
                src="https://ad.doubleclick.net/ddm/trackimp/N1215814.1920760BEZREALITKY/B27124403.328259894;dc_trk_aid=520556863;dc_trk_cid=166191266;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=?"
                height="1"
                width="1"
                alt="Advertisement"
            />
        </DetailAd>
    );
};
